import { createApp } from "vue";
import SimulatorPinel from './components/SimulatorPinel.vue';
import SimulatorPTZ from './components/SimulatorPTZ.vue';
import SimulatorNotary from './components/SimulatorNotary.vue';
import SimulatorLoan from './components/SimulatorLoan.vue';

if ( document.querySelector('#simulator-pinel') ) {
  createApp(SimulatorPinel).mount("#simulator-pinel");
}
if ( document.querySelector('#simulator-ptz') ) {
  createApp(SimulatorPTZ).mount("#simulator-ptz");
}
if ( document.querySelector('#simulator-notary') ) {
  createApp(SimulatorNotary).mount("#simulator-notary");
}
if ( document.querySelector('#simulator-loan') ) {
  createApp(SimulatorLoan).mount("#simulator-loan");
}
